import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { styled } from '@mui/system';
import MuiTypography from '@mui/material/Typography';
import { black } from '@cpg-its/ads.constants.colors';
const TypographyStyled = styled(MuiTypography)(({ color }) => ({
    color,
    margin: 0,
    padding: 0,
    '&.smallFont': {
        fontSize: '0.75rem',
        lineHeight: '1.125rem',
    },
    '&.mediumFont': {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
    },
    '&.largeFont': {
        fontSize: '1rem',
        lineHeight: '1.5rem',
    },
    '&.xlargeFont': {
        fontSize: '1.25rem',
    },
    '&.h1Font': {
        fontSize: '2rem',
        lineHeight: '2.5rem',
    },
    '&.h2Font': {
        fontSize: '1.5rem',
        lineHeight: '2rem',
    },
    '&.h3Font': {
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
    },
    '&.h4Font': {
        fontSize: '1rem',
        lineHeight: '1.5rem',
    },
    '&.h5Font': {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
    },
    '&.h6Font': {
        fontSize: '0.75rem',
        lineHeight: '1.125rem',
    },
    '&.extraSlim': {
        fontWeight: 100,
    },
    '&.slim': {
        fontWeight: 300,
    },
    '&.bold': {
        fontWeight: 500,
    },
    '&.extraBold': {
        fontWeight: 700,
    },
    '&.spaceAfter': {
        marginRight: '0.25rem',
    },
    '&.spaceBefore': {
        marginLeft: '0.25rem',
    },
    '&.underline': {
        textDecoration: 'underline',
    },
    '&.onClick': {
        cursor: 'pointer',
    },
    '&.italic': {
        fontStyle: 'italic',
    },
}));
export const TypographyComponent = ({ bold = false, color = black, component = 'div', extraBold = false, extraSlim = false, italic = false, onClick = undefined, size = 'medium', slim = false, spaceAfter = false, spaceBefore = false, testId = undefined, text = '', underline = false, variant = undefined, }) => {
    const afterSpace = spaceAfter ? 'spaceAfter' : '';
    const beforeSpace = spaceBefore ? 'spaceBefore' : '';
    const lineUnderneath = underline ? 'underline' : '';
    const onClickCursor = onClick ? 'onClick' : '';
    const fontItalic = italic ? 'italic' : '';
    const fontSize = variant ? '' : `${size}Font`;
    const fontBoldOrSlim = (() => {
        if (bold) {
            return 'bold';
        }
        if (extraBold) {
            return 'extraBold';
        }
        if (slim) {
            return 'slim';
        }
        if (extraSlim) {
            return 'extraSlim';
        }
        return '';
    })();
    if (text) {
        return (_jsx(TypographyStyled, { className: classNames(afterSpace, beforeSpace, fontSize, fontBoldOrSlim, fontItalic, lineUnderneath, onClickCursor), "data-testid": testId, onClick: onClick, component: component, variant: variant, color: color, children: text }));
    }
    return null;
};
export default TypographyComponent;
//# sourceMappingURL=typography.js.map